// Importes de una reserva tal como los devuelve la API (GET /api/r/{code} y la ficha del panel).
// total_amount es SOLO el alquiler; los extras elegidos van en extras_amount y la señal se calcula
// sobre los dos (backend/payment_plan.py).

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
const redondea = (n) => Math.round(n * 100) / 100;

// Lo que cuesta la reserva: alquiler más extras.
export function importeTotal(r) {
  return redondea(num(r?.total_amount) + num(r?.extras_amount));
}

// Plan de cobro del backend (payment_plan.plan_for), si la reserva lo trae.
const planDe = (r) => {
  const plan = r?.payment_plan;
  return plan && plan.stage !== "not_confirmed" ? plan : null;
};

// Lo que queda por cobrar del alquiler: lo que dice el plan (descuenta la señal pagada). Una reserva
// cuya señal ya lo cubrió no pide nada aunque su estado siga «pending» (reservas anteriores al arreglo).
export function pendienteAlquiler(r) {
  if (r?.rental_payment_status !== "pending") return 0;
  const plan = planDe(r);
  return redondea(Math.max(0, plan && plan.balance_amount != null ? num(plan.balance_amount) : num(r?.total_amount)));
}

// Lo que queda por cobrar de los extras: lo que dice el plan (la parte que pagó la señal no cuenta).
export function pendienteExtras(r) {
  if (r?.extras_payment_status === "paid") return 0;
  const plan = planDe(r);
  return redondea(Math.max(0, plan && plan.extras_amount != null ? num(plan.extras_amount) : num(r?.extras_amount)));
}

// Lo que queda por pagar después de la señal (pagada o por pagar): alquiler más los extras aún sin
// cobrar, menos la señal. Mismo cálculo que el correo de la reserva (backend/email_service.py) y que
// el cobro de antes de la entrega (saldo del plan más extras pendientes).
export function restoTrasSenal(r) {
  const plan = r?.payment_plan || {};
  const senal = plan.stage === "signal"
    ? num(plan.signal_amount)
    : r?.signal_payment_status === "paid" ? num(plan.signal_paid ?? r?.signal_amount) : 0;
  const extras = r?.extras_payment_status === "paid" ? 0 : num(r?.extras_amount);
  return redondea(Math.max(0, num(r?.total_amount) + extras - senal));
}
